module.exports = __webpack_public_path__ + "45fe5f48c370bcac9cd187ae86ce35e9.jpg";